// Code generated by @ads-platform/rtkq-codegen v1.1.1-feature-AP-2126-optional-3c29904f.6+3583ce4. EDIT ONLY TYPES IMPORT PATH IF NECESSARY.

import { separateApiAuth as api } from '#adapter/api/auth/separate-api-auth';

import * as Types from './types';

const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        postV2AuthSlideV3Confirm: build.mutation<
        Types.IPostV2AuthSlideV3ConfirmApiResponse,
        Types.IPostV2AuthSlideV3ConfirmApiArg
        >({
            query: (queryArg) => ({
                url    : '/v2/auth/slide-v3-confirm',
                method : 'POST',
                body   : queryArg.body,
                cookies: {
                    'wbx-refresh': queryArg['wbx-refresh']
                },
                headers: {
                    'wb-apptype'   : queryArg['wb-apptype'],
                    'wb-appversion': queryArg['wb-appversion'],
                    'X-Request-ID' : queryArg['X-Request-ID']
                }
            })
        })
    }),
    overrideExisting: false
});

export { injectedRtkApi as rtkApi };
export const { usePostV2AuthSlideV3ConfirmMutation } = injectedRtkApi;
